import { request } from './request';

export const discoverOrg = (email) =>
  request('/sso/discover?email=' + encodeURIComponent(email), 'GET');

export const getSsoConfig = (orgId) => request(`/organizations/${orgId}/sso`, 'GET');

export const saveSsoConfig = (orgId, config) =>
  request(`/organizations/${orgId}/sso`, 'POST', config);

export const activateSso = (orgId) => request(`/organizations/${orgId}/sso/activate`, 'POST');

export const deactivateSso = (orgId) => request(`/organizations/${orgId}/sso/deactivate`, 'POST');

export const testSso = (orgId) => request(`/organizations/${orgId}/sso/test`, 'POST');

export const deleteSsoConfig = (orgId) => request(`/organizations/${orgId}/sso`, 'DELETE');

export const getSpMetadata = () => request('/sso/sp-metadata', 'GET');
